class VideoHover extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.source = this.video ? this.video.querySelector('source') : null;
    if (!this.video || !this.source) return;

    this.dataSrc = this.source.getAttribute('data-src');
    this.loaded = false;

    this.isTouch = !window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (this.isTouch) {
      this.setupScrollAutoplay();
    } else {
      this.setupHover();
    }
  }

  ensureLoaded() {
    if (this.loaded || !this.dataSrc) return;
    this.source.setAttribute('src', this.dataSrc);
    this.video.load();
    this.loaded = true;
  }

  activate() {
    this.ensureLoaded();
    this.classList.add('is-active');
    const playPromise = this.video.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(() => {
        /* Autoplay may be blocked; fail silently, static image remains visible */
      });
    }
  }

  deactivate() {
    this.classList.remove('is-active');
    if (this.video && !this.video.paused) {
      this.video.pause();
      this.video.currentTime = 0;
    }
  }

  setupHover() {
    const target = this.closest('.card__media') || this.parentElement || this;
    target.addEventListener('mouseenter', () => this.activate());
    target.addEventListener('mouseleave', () => this.deactivate());
  }

  setupScrollAutoplay() {
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.activate();
          } else {
            this.deactivate();
          }
        });
      },
      { threshold: 0.6 }
    );

    observer.observe(this);
  }
}

customElements.define('video-hover', VideoHover);
